export const DEFAULT_VARIANT = 'primary'
